import { useEffect, useState, useCallback, useRef, useContext } from "react";
import React from "react";
import { useForm, Controller } from 'react-hook-form';
import AlertContext from '../../../GlobalComponents/Alert/contexts/alertContext';

//import global components
import { Card, Modal, ModalActionConfirm } from '../../../../imports';

//import icons from heroicons
import { EnvelopeIcon, UserIcon, PhoneIcon, MapPinIcon, ChatBubbleLeftIcon, DocumentTextIcon, CheckIcon, XMarkIcon, IdentificationIcon } from '@heroicons/react/24/outline';

//import services
import { ObtenerEspecialidades, ObtenerEstadoCivil, EditarPersona, ObtenerIDPersona, ObtenerInfoPersonalPorId } from '../../../../servicios/ServicioInfoPersonal';
import list from "../../../../../node_modules/postcss/lib/list";

import PhoneInput from 'react-phone-input-2';
import '../../../../../src/customInput.css';

import { Switch } from '@headlessui/react'

export default function InfoPersonal({ validationMessages, InfoPersonalData, setInfoPersonalData, finalData, stateInfoPersonal, setstateInfoPersonal, allowEdit, listInfoByPerson, InfoPersonalDataEdit, setInfoPersonalDataEdit, idCurriculum, isFirstLoadPersonalInformation, setIsFirstLoadPersonalInformation, isFirstLoadUserInfo, setIsFirstLoadUserInfo, listInfoByUser, refreshData }) {


    const isMounted = useRef(true);
    //use alert context
    const alertCtx = useContext(AlertContext);

    //validate if user already complete cv
    const userCompleteCV = sessionStorage.getItem("USER_COMPLETE_CV");

    //state to manage working in Rossmon
    const [enabled, setEnabled] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    // Control visibility of "Trabaja en IT Rossmon" switch - Mostrar solo en modo administrativo
    const showWorkSwitch = allowEdit === true;

    //here we pass a default input property to save in userData
    //all inputs use this same event in 'onchange'
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (InfoPersonalData) {
            setInfoPersonalData({ ...InfoPersonalData, [name]: value })
        }
        validateForm();

    };

    //use react hook form to get values and make validations
    const { register, getValues, trigger, unregister, watch, setValue, formState, control, resetField } = useForm({
        //this mode will get all type of events to trigger validations
        mode: "all",
        defaultValues: {
            firstName: '',
            secondName: '',
            surname: '',
            secondSurname: '',
            identification: '',
            birthDate: '',
            maritalStatus: '',
            email: '',
            firstPhoneNumber: '',
            secondPhoneNumber: '',
            residence: '',
            linkedin: '',
            otherSocialMedia: '',
            specialty: '',
            personalSummary: '',
            workInRossmon: false,
        },

    });

    const { errors } = formState;
    const { isValid } = formState;

    const handleChangeUserCompleteCV = (e) => {
        const { name, value } = e.target;

        if (InfoPersonalDataEdit) {
            setInfoPersonalDataEdit({ ...InfoPersonalDataEdit, [name]: value })
        }

    };


    //use modal and show for save
    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
    const [actionTypeConfirmModal, setActionTypeConfirmModal] = useState("");

    //set values from onchange in maritalStatus
    const selectMaritalStatus = (e) => {
        e.preventDefault();
        const maritalStatus = (e.target.value);

    }
    const jsonUsuario = sessionStorage.getItem("USER_DATA");
    const usuario = JSON.parse(jsonUsuario);
    const idUsuario = usuario.IdUsuario;


    //method to edit project from person by id
    const EditarInfoPersonalPersona = async (e) => {

        // Re-validate form on save to ensure isValid is up-to-date
        const ok = await trigger();
        if (!ok) {
            alertCtx.error('Por favor corrija los errores del formulario antes de actualizar.');
            return;
        }

        const email = getValues("email");
        const firstName = getValues("firstName");
        const secondName = getValues("secondName");
        const surname = getValues("surname");
        const secondSurname = getValues("secondSurname");
        const identification = getValues("identification");
        const birthDate = getValues("birthDate");
        const firstPhoneNumberValue = getValues("firstPhoneNumber");
        const secondPhoneNumberValue = getValues("secondPhoneNumber");
        const residence = getValues("residence");
        const maritalStatus = getValues("maritalStatus");
        const linkedin = getValues("linkedin");
        const otherSocialMedia = getValues("otherSocialMedia");
        const personalSummary = getValues("personalSummary");
        const specialty = getValues("specialty");

        // ensure we have an idPersona to send to the API
        let personaId = idCurriculum;
        if (!personaId) {
            try {
                const idResp = await ObtenerIDPersona(idUsuario);
                personaId = idResp?.IdPersona || idResp?.idPersona || null;
            } catch (err) {
                console.error('Error obteniendo IdPersona antes de editar:', err);
            }
        }

        const dataPersona = {
            idPersona: personaId,
            correoElectronico: email,
            primerNombre: firstName,
            segundoNombre: secondName,
            primerApellido: surname,
            segundoApellido: secondSurname,
            identificacion: identification,
            fechaNacimiento: birthDate,
            telefono1: firstPhoneNumberValue,
            telefono2: secondPhoneNumberValue,
            lugarResidencia: residence,
            idEstadoCivil: parseInt(maritalStatus, 10),
            linkedIn: linkedin,
            otraRedSocial: otherSocialMedia,
            trabajaEnRossmon: Boolean(enabled),
            resumenPersonal: personalSummary,
            idUsuario: parseInt(idUsuario, 10),
            idEspecializacion: parseInt(specialty, 10),
        };

        if (isValid) {
            console.log('EditarInfoPersonalPersona: idCurriculum=', idCurriculum);
            console.log('EditarInfoPersonalPersona: payload=', dataPersona);
            const response = await EditarPersona(dataPersona);
            console.log('EditarInfoPersonalPersona: response=', response);

            // Close modal and show result
            setShowConfirmSaveModal(false);
            if (response && response.indicador === 0) {
                alertCtx.success(response.mensaje || 'Actualizado correctamente');
                // Actualizar el estado de InfoPersonalDataEdit con el nuevo valor
                if (InfoPersonalDataEdit) {
                    setInfoPersonalDataEdit({
                        ...InfoPersonalDataEdit,
                        "workInRossmon": enabled
                    });
                }
                if (InfoPersonalData) {
                    setInfoPersonalData({
                        ...InfoPersonalData,
                        "workInRossmon": enabled
                    });
                }
                // Recargar los datos del servidor
                await recargarDatosPersona();
            } else {
                alertCtx.error(response?.mensaje || 'Error al actualizar la información');
            }
        } else {
            alertCtx.error("¡Error al editar la información!");
        }

    }

    // Función para recargar los datos de la persona desde el servidor
    const recargarDatosPersona = async () => {
        try {
            let personaId = idCurriculum;
            if (!personaId) {
                const idResp = await ObtenerIDPersona(idUsuario);
                personaId = idResp?.IdPersona || idResp?.idPersona || null;
            }
            if (personaId) {
                const response = await ObtenerInfoPersonalPorId(personaId);
                console.log('Datos recargados del servidor:', response);

                if (response && (response.IdPersona || response.idPersona)) {
                    const data = response;
                    // Actualizar el estado con los datos frescos del servidor
                    if (InfoPersonalDataEdit) {
                        setInfoPersonalDataEdit({
                            ...InfoPersonalDataEdit,
                            ...data,
                            "workInRossmon": data.trabajaEnRossmon
                        });
                    }
                    if (InfoPersonalData) {
                        setInfoPersonalData({
                            ...InfoPersonalData,
                            ...data,
                            "workInRossmon": data.trabajaEnRossmon
                        });
                    }
                    setEnabled(data.trabajaEnRossmon);
                    setValue("workInRossmon", data.trabajaEnRossmon);
                }
            }
        } catch (error) {
            console.error('Error recargando datos:', error);
        }
    };

    // Función para guardar solo el switch
    const guardarSwitch = async (nuevoValor) => {
        if (isSaving) return;
        setIsSaving(true);

        try {
            // Obtener el idPersona
            let personaId = idCurriculum;
            if (!personaId) {
                const idResp = await ObtenerIDPersona(idUsuario);
                personaId = idResp?.IdPersona || idResp?.idPersona || null;
            }

            if (!personaId) {
                alertCtx.error('No se pudo obtener el ID de la persona');
                setIsSaving(false);
                return;
            }

            // Obtener los datos actuales de la persona
            const personaActual = await ObtenerInfoPersonalPorId(personaId);
            console.log('📥 Datos actuales de la persona:', personaActual);

            // Crear el objeto con TODOS los campos usando los datos existentes
            const dataPersona = {
                idPersona: personaId,
                correoElectronico: personaActual.correoElectronico || '',
                primerNombre: personaActual.primerNombre || '',
                segundoNombre: personaActual.segundoNombre || '',
                primerApellido: personaActual.primerApellido || '',
                segundoApellido: personaActual.segundoApellido || '',
                identificacion: personaActual.identificacion || '',
                fechaNacimiento: personaActual.fechaNacimiento || new Date().toISOString().split('T')[0],
                telefono1: personaActual.telefono1 || '',
                telefono2: personaActual.telefono2 || '',
                lugarResidencia: personaActual.lugarResidencia || '',
                idEstadoCivil: personaActual.idEstadoCivil || 1,
                linkedIn: personaActual.linkedIn || '',
                otraRedSocial: personaActual.otraRedSocial || '',
                trabajaEnRossmon: Boolean(nuevoValor),
                resumenPersonal: personaActual.resumenPersonal || '',
                idUsuario: parseInt(idUsuario, 10),
                idEspecializacion: personaActual.idEspecializacion || 1,
            };

            console.log('📤 Guardando switch con payload:', dataPersona);
            const response = await EditarPersona(dataPersona);
            console.log('📥 Respuesta del servidor:', response);

            if (response && response.indicador === 0) {
                // Actualizar el estado local
                setEnabled(nuevoValor);
                setValue("workInRossmon", nuevoValor);

                // Actualizar los estados de datos
                if (InfoPersonalDataEdit) {
                    setInfoPersonalDataEdit({
                        ...InfoPersonalDataEdit,
                        "workInRossmon": nuevoValor
                    });
                }
                if (InfoPersonalData) {
                    setInfoPersonalData({
                        ...InfoPersonalData,
                        "workInRossmon": nuevoValor
                    });
                }

                alertCtx.success('Estado actualizado correctamente');

                // Recargar datos para confirmar
                await recargarDatosPersona();

                // Si hay una función de refresh, llamarla
                if (refreshData) {
                    refreshData();
                }
            } else {
                alertCtx.error(response?.mensaje || 'Error al actualizar el estado');
                // Revertir el switch si hubo error
                setEnabled(!nuevoValor);
                setValue("workInRossmon", !nuevoValor);
            }
        } catch (error) {
            console.error('❌ Error al guardar el switch:', error);
            alertCtx.error('Error al actualizar el estado');
            setEnabled(!nuevoValor);
            setValue("workInRossmon", !nuevoValor);
        } finally {
            setIsSaving(false);
        }
    };


    //custom phone inputs
    const [firstPhoneNumber, setFirstPhoneNumber] = useState('');
    const [secondPhoneNumber, setSecondPhoneNumber] = useState('');

    const [isValidFirstPhoneNumber, setIsValidFirstPhoneNumber] = useState(true)

    //use to get validations from props and later iterate
    const [validations, setValidations] = useState([]);

    //use to get maritalStatus options
    const [maritalStatusOptions, setMaritalStatusOptions] = useState([]);

    //use to get specialty options
    const [specialtyOptions, setSpecialtyOptions] = useState([]);

    //function to save 'especialidades' in list
    async function getEspecialties() {
        const response = await ObtenerEspecialidades();

        if (response !== undefined) {

            setSpecialtyOptions(response);
        }
    }

    //function to save 'estadoCivil' in list
    async function getMaritalStatus() {
        const response = await ObtenerEstadoCivil();

        if (response !== undefined) {

            setMaritalStatusOptions(response);
        }
    }

    //unregister controls from select and then set again values to focus input
    const keepValuesFromList = useCallback(() => {
        if (getValues("maritalStatus")) {
            unregister(["maritalStatus"])

            setValue("maritalStatus", InfoPersonalData?.maritalStatus);
        }

        if (getValues("firstPhoneNumber")) {
            unregister(["firstPhoneNumber"])

            setValue("firstPhoneNumber", InfoPersonalData?.firstPhoneNumber);
        }

        if (finalData?.specialty) {
            const timeout = setTimeout(() => {
                unregister("specialty")
                setValue("specialty", InfoPersonalData?.specialty);

            }, 1000);
            return () => clearTimeout(timeout);
        }

    }, [])

    const keepValuesFromListByPerson = () => {

        const firstName = getValues("firstName");
        const secondName = getValues("secondName");
        const surname = getValues("surname");
        const secondSurname = getValues("secondSurname");
        const identification = getValues("identification");
        const birthDate = getValues("birthDate");
        const maritalStatus = getValues("maritalStatus");
        const email = getValues("email");
        const firstPhoneNumber = getValues("firstPhoneNumber");
        const secondPhoneNumber = getValues("secondPhoneNumber");
        const residence = getValues("residence");
        const linkedin = getValues("linkedin");
        const otherSocialMedia = getValues("otherSocialMedia");
        const specialty = getValues("specialty");
        const personalSummary = getValues("personalSummary");
        const workInRossmon = getValues("workInRossmon");

        if (InfoPersonalDataEdit) {
            setInfoPersonalDataEdit({
                ...InfoPersonalDataEdit, ["firstName"]: firstName, ["secondName"]: secondName, ["surname"]: surname, ["secondSurname"]: secondSurname, ["identification"]: identification, ["birthDate"]: birthDate, ["maritalStatus"]: maritalStatus, ["email"]: email, ["firstPhoneNumber"]: firstPhoneNumber, ["secondPhoneNumber"]: secondPhoneNumber, ["residence"]: residence, ["linkedIn"]: linkedin, ["otherSocialMedia"]: otherSocialMedia, ["specialty"]: specialty, ["personalSummary"]: personalSummary, ["workInRossmon"]: workInRossmon
            })
        }
    }

    const setValuesFromUserDataEdit = () => {

        if (InfoPersonalDataEdit) {
            setValue("firstName", InfoPersonalDataEdit?.firstName)
            setValue("secondName", InfoPersonalDataEdit?.secondName)
            setValue("surname", InfoPersonalDataEdit?.surname)
            setValue("secondSurname", InfoPersonalDataEdit?.secondSurname)
            setValue("identification", InfoPersonalDataEdit?.identification)
            setValue("birthDate", InfoPersonalDataEdit?.birthDate)
            setValue("maritalStatus", InfoPersonalDataEdit?.maritalStatus)
            setValue("email", InfoPersonalDataEdit?.email)
            setValue("firstPhoneNumber", InfoPersonalDataEdit?.firstPhoneNumber)
            setValue("secondPhoneNumber", InfoPersonalDataEdit?.secondPhoneNumber)
            setValue("residence", InfoPersonalDataEdit?.residence)
            setValue("linkedin", InfoPersonalDataEdit?.linkedIn)
            setValue("otherSocialMedia", InfoPersonalDataEdit?.otherSocialMedia)
            setValue("specialty", InfoPersonalDataEdit?.specialty)
            setValue("personalSummary", InfoPersonalDataEdit?.personalSummary)
            setValue("workInRossmon", InfoPersonalDataEdit?.workInRossmon)
            setEnabled(InfoPersonalDataEdit?.workInRossmon)
        }
    }

    const setValuesFromUserData = () => {
        if (InfoPersonalData) {
            setValue("firstName", InfoPersonalData?.firstName)
            setValue("secondName", InfoPersonalData?.secondName)
            setValue("surname", InfoPersonalData?.surname)
            setValue("secondSurname", InfoPersonalData?.secondSurname)
            setValue("identification", InfoPersonalData?.identification)
            setValue("birthDate", InfoPersonalData?.birthDate)
            setValue("maritalStatus", InfoPersonalData?.maritalStatus)
            setValue("email", InfoPersonalData?.email)
            setValue("firstPhoneNumber", InfoPersonalData?.firstPhoneNumber)
            setValue("secondPhoneNumber", InfoPersonalData?.secondPhoneNumber)
            setValue("residence", InfoPersonalData?.residence)
            setValue("linkedin", InfoPersonalData?.linkedin)
            setValue("otherSocialMedia", InfoPersonalData?.otherSocialMedia)
            setValue("specialty", InfoPersonalData?.specialty)
            setValue("personalSummary", InfoPersonalData?.personalSummary)
            setValue("workInRossmon", InfoPersonalData?.workInRossmon)
            setEnabled(InfoPersonalData?.workInRossmon)
        }
    }



    const validateForm = useCallback(() => {

        let state = false;

        isValid ? state = true : state = false;

        setstateInfoPersonal(state);



    }, [isValid])




    //create custom object with list by person id to render inputs
    function customObjectByPersonList() {

        if (listInfoByPerson) {
            const startMonth = new Date(listInfoByPerson?.fechaNacimiento).getMonth() + 1;
            const startYear = new Date(listInfoByPerson?.fechaNacimiento).getFullYear();
            const startDay = new Date(listInfoByPerson?.fechaNacimiento).getDate();
            const startDateFormatted = `${startYear}-${startMonth}-${startDay}`;
            const date = new Date(startDateFormatted)

            setValue("firstName", listInfoByPerson?.primerNombre)
            setValue("secondName", listInfoByPerson?.segundoNombre)
            setValue("surname", listInfoByPerson?.primerApellido)
            setValue("secondSurname", listInfoByPerson?.segundoApellido)
            setValue("identification", listInfoByPerson?.identificacion)
            setValue("birthDate", date.toLocaleDateString('fr-CA'))
            setValue("maritalStatus", listInfoByPerson?.idEstadoCivil)

            setValue("email", listInfoByPerson?.correoElectronico)
            setValue("firstPhoneNumber", listInfoByPerson?.telefono1)
            setValue("secondPhoneNumber", listInfoByPerson?.telefono2)
            setValue("residence", listInfoByPerson?.lugarResidencia)
            setValue("linkedin", listInfoByPerson?.linkedIn)
            setValue("otherSocialMedia", listInfoByPerson?.otraRedSocial)
            setValue("specialty", listInfoByPerson?.idEspecializacion)
            setValue("personalSummary", listInfoByPerson?.resumenPersonal)
            setValue("workInRossmon", listInfoByPerson?.trabajaEnRossmon)
            setEnabled(listInfoByPerson?.trabajaEnRossmon)

        }

    }


    const fillDatauser = () => {

        setValue("firstName", listInfoByUser?.nombre)
        setValue("secondName", listInfoByUser?.segundoNombre)
        setValue("surname", listInfoByUser?.primerApellido)
        setValue("secondSurname", listInfoByUser?.segundoApellido)
        setValue("email", listInfoByUser?.correo)
        setValue("firstPhoneNumber", listInfoByUser?.telefono)

        setInfoPersonalData({
            ...InfoPersonalData, ["firstName"]: listInfoByUser?.nombre, ["secondName"]: listInfoByUser?.segundoNombre, ["surname"]: listInfoByUser?.primerApellido, ["secondSurname"]: listInfoByUser?.segundoApellido, ["email"]: listInfoByUser?.correo, ["firstPhoneNumber"]: listInfoByUser?.telefono
        })


    }


    useEffect(() => {
        getEspecialties();
        getMaritalStatus();
        //validate for candidate view or admin view
        if (userCompleteCV === "true" && isFirstLoadPersonalInformation || allowEdit === true && isFirstLoadPersonalInformation) {
            //call methods to execute services

            customObjectByPersonList();
            if (isFirstLoadPersonalInformation) setIsFirstLoadPersonalInformation(false)
        }

        setValidations(validationMessages);
        //validate for candidate view or admin view
        if (userCompleteCV === "true" && !isFirstLoadPersonalInformation || allowEdit === true && !isFirstLoadPersonalInformation) {
            if (InfoPersonalDataEdit) {
                setValuesFromUserDataEdit();

            }
        } else {
            if (InfoPersonalData) {
                setValuesFromUserData();
                keepValuesFromList();
            }

        }


        return (() => {
            //validate for candidate view or admin view
            if (userCompleteCV === "true" || allowEdit === true) {
                if (isFirstLoadPersonalInformation) {
                    setIsFirstLoadPersonalInformation(false);
                }
                keepValuesFromListByPerson();
            } else {
                if (stateInfoPersonal) {
                    setstateInfoPersonal(isValid)
                }
            }
            setMaritalStatusOptions([]);
            setSpecialtyOptions([]);
        })


    }, [keepValuesFromList])

    useEffect(() => {
        if (userCompleteCV === "false") {

            const timeout = setTimeout(() => {
                if (isFirstLoadUserInfo) {
                    fillDatauser();

                    setIsFirstLoadUserInfo(false);
                }
            }, 1000);
            return () => clearTimeout(timeout);
        }
    }, [listInfoByUser])


    return (
        <div className="w-full max-w-5xl mx-auto px-4 py-6">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <Modal isVisible={showConfirmSaveModal} onClose={() => { setShowConfirmSaveModal(false) }} handleSubmit={() => null} onSaveOptions={null} showFotter={false} showCloseIcon={false}>
                    <ModalActionConfirm onSaveAction={EditarInfoPersonalPersona} actionType={actionTypeConfirmModal} setshowConfirmModal={setShowConfirmSaveModal} />
                </Modal>

                <form className="p-8">
                    {/* ============================================ */}
                    {/* BOTÓN ACTUALIZAR - Solo para admin */}
                    {/* ============================================ */}
                    {!allowEdit && userCompleteCV === "true" && (
                        <div className="flex justify-end mb-6">
                            <button
                                onClick={async () => {
                                    const ok = await trigger();
                                    if (ok && getValues("firstPhoneNumber") && getValues("firstPhoneNumber").length > 0) {
                                        setActionTypeConfirmModal("Editar");
                                        setShowConfirmSaveModal(true);
                                    } else {
                                        alertCtx.error('Por favor corrija los errores del formulario antes de actualizar.');
                                    }
                                }}
                                type="button"
                                className="px-6 py-2.5 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg text-sm transition-colors"
                            >
                                Actualizar
                            </button>
                        </div>
                    )}

                    {/* ============================================ */}
                    {/* SECCIÓN 1: INFORMACIÓN PERSONAL */}
                    {/* ============================================ */}
                    <div className="mb-8">
                        <h2 className="text-xl font-bold text-gray-800 mb-6 pb-2 border-b-2 border-gray-200">
                            Información Personal
                        </h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
                            {/* Primer nombre */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Primer nombre <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <input type="text"
                                        name="firstName"
                                        maxLength="25"
                                        {...register("firstName", { onChange: userCompleteCV === "true" ? handleChangeUserCompleteCV : handleChange, required: true, maxLength: 25, pattern: /^[a-zA-ZñÑ\s\W]/ })}
                                        id="firstName"
                                        disabled={allowEdit}
                                        className="w-full px-4 py-2.5 text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500"
                                        placeholder="Ej: Juan"
                                    />
                                    <UserIcon className="absolute right-3 top-3 h-5 w-5 text-gray-400" />
                                </div>
                                {validations.firstName?.map((values) => (
                                    errors.firstName?.type === values.type &&
                                    <p key={values.type} className="text-sm font-medium text-red-500 mt-1">{values.message}</p>
                                ))}
                            </div>

                            {/* Segundo nombre */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Segundo nombre
                                </label>
                                <div className="relative">
                                    <input type="text"
                                        name="secondName"
                                        maxLength="25"
                                        {...register('secondName', {
                                            onChange: userCompleteCV === "true" ? handleChangeUserCompleteCV : handleChange, maxLength: 25, pattern: /^[a-zA-ZñÑ\s\W]/
                                        })}
                                        id="secondName"
                                        disabled={allowEdit}
                                        className="w-full px-4 py-2.5 text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500"
                                        placeholder="Ej: Antonio"
                                    />
                                    <UserIcon className="absolute right-3 top-3 h-5 w-5 text-gray-400" />
                                </div>
                                {validations.secondName?.map((values) => (
                                    errors.secondName?.type === values.type &&
                                    <p key={values.type} className="text-sm font-medium text-red-500 mt-1">{values.message}</p>
                                ))}
                            </div>

                            {/* Primer apellido */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Primer apellido <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <input type="text"
                                        name="surname"
                                        maxLength="25"
                                        {...register('surname', { onChange: userCompleteCV === "true" ? handleChangeUserCompleteCV : handleChange, required: true, maxLength: 25, pattern: /^[a-zA-ZñÑ\s\W]/ })}
                                        id="surname"
                                        disabled={allowEdit}
                                        className="w-full px-4 py-2.5 text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500"
                                        placeholder="Ej: Pérez"
                                    />
                                    <UserIcon className="absolute right-3 top-3 h-5 w-5 text-gray-400" />
                                </div>
                                {validations.surname?.map((values) => (
                                    errors.surname?.type === values.type &&
                                    <p key={values.type} className="text-sm font-medium text-red-500 mt-1">{values.message}</p>
                                ))}
                            </div>

                            {/* Segundo apellido */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Segundo apellido <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <input type="text"
                                        name="secondSurname"
                                        maxLength="25"
                                        {...register('secondSurname', { onChange: userCompleteCV === "true" ? handleChangeUserCompleteCV : handleChange, required: true, maxLength: 25, pattern: /^[a-zA-ZñÑ\s\W]/ })}
                                        id="secondSurname"
                                        disabled={allowEdit}
                                        className="w-full px-4 py-2.5 text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500"
                                        placeholder="Ej: García"
                                    />
                                    <UserIcon className="absolute right-3 top-3 h-5 w-5 text-gray-400" />
                                </div>
                                {validations.secondSurname?.map((values) => (
                                    errors.secondSurname?.type === values.type &&
                                    <p key={values.type} className="text-sm font-medium text-red-500 mt-1">{values.message}</p>
                                ))}
                            </div>

                            {/* Identificación */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Identificación (C.I./FUC) <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <input type="text"
                                        name="identification"
                                        maxLength="11"
                                        {...register('identification', {
                                            onChange: userCompleteCV === "true" ? handleChangeUserCompleteCV : handleChange, required: true, maxLength: 11, pattern: /[0-9]/
                                        })}
                                        id="identification"
                                        disabled={allowEdit}
                                        className="w-full px-4 py-2.5 text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500"
                                        placeholder="1-1234-5678"
                                    />
                                    <IdentificationIcon className="absolute right-3 top-3 h-5 w-5 text-gray-400" />
                                </div>
                                {validations.identification?.map((values) => (
                                    errors.identification?.type === values.type &&
                                    <p key={values.type} className="text-sm font-medium text-red-500 mt-1">{values.message}</p>
                                ))}
                            </div>

                            {/* Fecha nacimiento */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Fecha de Nacimiento <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <input type="date"
                                        name="birthDate"
                                        {...register('birthDate', { onChange: userCompleteCV === "true" ? handleChangeUserCompleteCV : handleChange, required: true })}
                                        id="birthDate"
                                        disabled={allowEdit}
                                        className="w-full px-4 py-2.5 text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500"
                                    />
                                </div>
                                {validations.birthDate?.map((values) => (
                                    errors.birthDate?.type === values.type &&
                                    <p key={values.type} className="text-sm font-medium text-red-500 mt-1">{values.message}</p>
                                ))}
                            </div>

                            {/* Estado civil */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Estado civil <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <select
                                        id="maritalStatus"
                                        {...register('maritalStatus', { onChange: userCompleteCV === "true" ? handleChangeUserCompleteCV : handleChange, required: true })}
                                        type="select"
                                        disabled={allowEdit}
                                        value={getValues("maritalStatus")}
                                        className="w-full px-4 py-2.5 text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500 appearance-none"
                                        name="maritalStatus"
                                    >
                                        <option value={""} defaultValue>Seleccione...</option>
                                        {maritalStatusOptions?.map((option, index) => (
                                            <option key={index} value={option.idEstadoCivil}>{option.estado}</option>
                                        ))}
                                    </select>
                                </div>
                                {validations.maritalStatus?.map((values) => (
                                    errors.maritalStatus?.type === values.type &&
                                    <p key={values.type} className="text-sm font-medium text-red-500 mt-1">{values.message}</p>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* ============================================ */}
                    {/* SECCIÓN 2: INFORMACIÓN DE CONTACTO */}
                    {/* ============================================ */}
                    <div className="mb-8">
                        <h2 className="text-xl font-bold text-gray-800 mb-6 pb-2 border-b-2 border-gray-200">
                            Información de Contacto
                        </h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
                            {/* Correo electrónico */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Correo Electrónico <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <input type="text"
                                        name="email"
                                        maxLength="32"
                                        {...register('email', { onChange: userCompleteCV === "true" ? handleChangeUserCompleteCV : handleChange, required: true, maxLength: 32, pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/ })}
                                        id="email"
                                        disabled={allowEdit}
                                        className="w-full px-4 py-2.5 text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500"
                                        placeholder="email@ejemplo.com"
                                    />
                                    <EnvelopeIcon className="absolute right-3 top-3 h-5 w-5 text-gray-400" />
                                </div>
                                {validations.email?.map((values) => (
                                    errors.email?.type === values.type &&
                                    <p key={values.type} className="text-sm font-medium text-red-500 mt-1">{values.message}</p>
                                ))}
                            </div>

                            {/* Teléfono 1 */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Teléfono Principal <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <Controller
                                        control={control}
                                        name="firstPhoneNumber"
                                        rules={{
                                            required: 'Favor ingresar un teléfono',
                                            maxLength: {
                                                value: 15,
                                                message: 'El número telefónico no puede contener más de 15 caracteres'
                                            }
                                        }}
                                        render={({ field, fieldState: { error } }) => (
                                            <PhoneInput
                                                {...field}
                                                specialLabel={''}
                                                country={'cr'}
                                                disabled={allowEdit}
                                                placeholder="7643-1234"
                                                enableLongNumbers={true}
                                                countryCodeEditable={false}
                                                inputStyle={{
                                                    width: '100%',
                                                    height: '46px',
                                                    paddingLeft: '110px',
                                                    paddingRight: '44px',
                                                    fontSize: '14px',
                                                    border: '2px solid #d1d5db',
                                                    borderRadius: '8px',
                                                    transition: 'all 0.2s ease',
                                                    backgroundColor: allowEdit ? '#f3f4f6' : 'white',
                                                    color: allowEdit ? '#6b7280' : '#111827',
                                                    cursor: allowEdit ? 'not-allowed' : 'text',
                                                    outline: 'none',
                                                }}
                                                buttonStyle={{
                                                    position: 'absolute',
                                                    top: '0',
                                                    bottom: '0',
                                                    left: '0',
                                                    border: '2px solid #d1d5db',
                                                    borderRight: '2px solid #d1d5db',
                                                    borderRadius: '8px 0 0 8px',
                                                    backgroundColor: 'white',
                                                    padding: '0 12px',
                                                    minWidth: '95px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '4px',
                                                }}
                                                containerStyle={{
                                                    width: '100%',
                                                }}
                                                onChange={(value, country) => {
                                                    field.onChange(value);
                                                    setValue("firstPhoneNumber", value);
                                                    if (userCompleteCV === "true") {
                                                        if (InfoPersonalDataEdit) {
                                                            setInfoPersonalDataEdit({
                                                                ...InfoPersonalDataEdit, "firstPhoneNumber": value
                                                            });
                                                        }
                                                    } else {
                                                        if (InfoPersonalData) {
                                                            setInfoPersonalData({ ...InfoPersonalData, "firstPhoneNumber": value });
                                                        }
                                                        validateForm();
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                    <PhoneIcon className="absolute right-3 top-3.5 h-5 w-5 text-gray-400 pointer-events-none" />
                                    {errors.firstPhoneNumber && (
                                        <p className="text-sm font-medium text-red-500 mt-1">{errors.firstPhoneNumber.message}</p>
                                    )}
                                </div>
                            </div>

                            {/* Dirección de Residencia */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Dirección de Residencia <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <input type="text"
                                        name="residence"
                                        maxLength="100"
                                        minLength="20"
                                        disabled={allowEdit}
                                        {...register('residence', { onChange: userCompleteCV === "true" ? handleChangeUserCompleteCV : handleChange, required: true, maxLength: 100, minLength: 20 })}
                                        id="residence"
                                        className="w-full px-4 py-2.5 text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500"
                                        placeholder="Calle, Número, Ciudad"
                                    />
                                    <MapPinIcon className="absolute right-3 top-3 h-5 w-5 text-gray-400" />
                                </div>
                                {validations.residence?.map((values) => (
                                    errors.residence?.type === values.type &&
                                    <p key={values.type} className="text-sm font-medium text-red-500 mt-1">{values.message}</p>
                                ))}
                            </div>

                            {/* Teléfono 2 */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Teléfono Secundario
                                </label>
                                <div className="relative">
                                    <PhoneInput
                                        required
                                        specialLabel={''}
                                        country={'cr'}
                                        value={getValues("secondPhoneNumber")}
                                        disabled={allowEdit}
                                        enableLongNumbers={true}
                                        countryCodeEditable={false}
                                        onChange={(value, country) => {
                                            setValue("secondPhoneNumber", value)
                                            if (userCompleteCV === "true") {
                                                if (InfoPersonalDataEdit) {
                                                    setInfoPersonalDataEdit({
                                                        ...InfoPersonalDataEdit, "secondPhoneNumber": value
                                                    })
                                                }
                                            } else {
                                                if (InfoPersonalData) {
                                                    setInfoPersonalData({ ...InfoPersonalData, "secondPhoneNumber": value })
                                                }
                                            }
                                        }}
                                        placeholder="7643-1234"
                                        inputStyle={{
                                            width: '100%',
                                            height: '46px',
                                            paddingLeft: '110px',
                                            paddingRight: '44px',
                                            fontSize: '14px',
                                            border: '2px solid #d1d5db',
                                            borderRadius: '8px',
                                            transition: 'all 0.2s ease',
                                            backgroundColor: allowEdit ? '#f3f4f6' : 'white',
                                            color: allowEdit ? '#6b7280' : '#111827',
                                            cursor: allowEdit ? 'not-allowed' : 'text',
                                            outline: 'none',
                                        }}
                                        buttonStyle={{
                                            position: 'absolute',
                                            top: '0',
                                            bottom: '0',
                                            left: '0',
                                            border: '2px solid #d1d5db',
                                            borderRight: '2px solid #d1d5db',
                                            borderRadius: '8px 0 0 8px',
                                            backgroundColor: 'white',
                                            padding: '0 12px',
                                            minWidth: '95px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '4px',
                                        }}
                                        containerStyle={{
                                            width: '100%',
                                        }}
                                    />
                                    <PhoneIcon className="absolute right-3 top-3.5 h-5 w-5 text-gray-400 pointer-events-none" />
                                </div>
                            </div>

                            {/* LinkedIn */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    LinkedIn
                                </label>
                                <div className="relative">
                                    <input type="text"
                                        name="linkedin"
                                        maxLength="50"
                                        disabled={allowEdit}
                                        {...register('linkedin', { onChange: userCompleteCV === "true" ? handleChangeUserCompleteCV : handleChange, required: false, maxLength: 50 })}
                                        id="linkedin"
                                        className="w-full px-4 py-2.5 text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500"
                                        placeholder="linkedin.com/in/usuario"
                                    />
                                    <ChatBubbleLeftIcon className="absolute right-3 top-3 h-5 w-5 text-gray-400" />
                                </div>
                                {validations.linkedin?.map((values) => (
                                    errors.linkedin?.type === values.type &&
                                    <p key={values.type} className="text-sm font-medium text-red-500 mt-1">{values.message}</p>
                                ))}
                            </div>

                            {/* Otra red social */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Otra Red Social
                                </label>
                                <div className="relative">
                                    <input type="text"
                                        name="otherSocialMedia"
                                        maxLength="50"
                                        disabled={allowEdit}
                                        {...register('otherSocialMedia', { onChange: userCompleteCV === "true" ? handleChangeUserCompleteCV : handleChange, required: false, maxLength: 50 })}
                                        id="otherSocialMedia"
                                        className="w-full px-4 py-2.5 text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500"
                                        placeholder="@usuario_red"
                                    />
                                    <ChatBubbleLeftIcon className="absolute right-3 top-3 h-5 w-5 text-gray-400" />
                                </div>
                                {validations.otherSocialMedia?.map((values) => (
                                    errors.otherSocialMedia?.type === values.type &&
                                    <p key={values.type} className="text-sm font-medium text-red-500 mt-1">{values.message}</p>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* ============================================ */}
                    {/* SECCIÓN 3: PERFIL PROFESIONAL */}
                    {/* ============================================ */}
                    <div className="mb-8">
                        <h2 className="text-xl font-bold text-gray-800 mb-6 pb-2 border-b-2 border-gray-200">
                            Perfil Profesional
                        </h2>

                        <div className="grid grid-cols-1 gap-y-4">
                            {/* Especialidad */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Especialidad Principal <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <select
                                        {...register('specialty', { onChange: userCompleteCV === "true" ? handleChangeUserCompleteCV : handleChange, required: true })}
                                        id="specialty"
                                        type="select"
                                        disabled={allowEdit}
                                        value={getValues("specialty")}
                                        className="w-full px-4 py-2.5 text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500 appearance-none"
                                        name="specialty"
                                    >
                                        <option value={""} defaultValue>Seleccione su área...</option>
                                        {specialtyOptions.map((option, index) => (
                                            <option key={index} value={option.idEspecializacion}>{option.nombreEspecializacion}</option>
                                        ))}
                                    </select>
                                </div>
                                {validations.specialty?.map((values) => (
                                    errors.specialty?.type === values.type &&
                                    <p key={values.type} className="text-sm font-medium text-red-500 mt-1">{values.message}</p>
                                ))}
                            </div>

                            {/* Resumen personal */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Resumen Personal <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <textarea
                                        name="personalSummary"
                                        disabled={allowEdit}
                                        rows="4"
                                        {...register('personalSummary', { onChange: userCompleteCV === "true" ? handleChangeUserCompleteCV : handleChange, required: true })}
                                        id="personalSummary"
                                        className="w-full px-4 py-2.5 text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500 resize-y"
                                        placeholder="Descripción de tus logros, habilidades clave y lo que buscas en tu próximo reto profesional..."
                                    />
                                    <DocumentTextIcon className="absolute right-3 top-3 h-5 w-5 text-gray-400" />
                                </div>
                                {validations.personalSummary?.map((values) => (
                                    errors.personalSummary?.type === values.type &&
                                    <p key={values.type} className="text-sm font-medium text-red-500 mt-1">{values.message}</p>
                                ))}
                            </div>

                            {/* ============================================ */}
                            {/* SWITCH TRABAJA EN ROSS MON - Solo admin */}
                            {/* ============================================ */}
                            {showWorkSwitch && (
                                <div className="mt-4 pt-4 border-t border-gray-200">
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <h3 className="text-sm font-medium text-gray-900">Trabaja en IT Rossmon</h3>
                                            <p className="text-sm text-gray-500">
                                                Marque esta opción si el colaborador actualmente trabaja en IT Rossmon
                                            </p>
                                        </div>
                                        <div className="flex items-center gap-4">
                                            <Switch
                                                checked={enabled}
                                                onChange={async () => {
                                                    const nuevoValor = !enabled;
                                                    // Actualizar visualmente primero
                                                    setEnabled(nuevoValor);
                                                    setValue("workInRossmon", nuevoValor);

                                                    // Actualizar estados locales
                                                    if (userCompleteCV === "true") {
                                                        if (InfoPersonalDataEdit) {
                                                            setInfoPersonalDataEdit({
                                                                ...InfoPersonalDataEdit,
                                                                "workInRossmon": nuevoValor
                                                            });
                                                        }
                                                    } else {
                                                        if (InfoPersonalData) {
                                                            setInfoPersonalData({
                                                                ...InfoPersonalData,
                                                                "workInRossmon": nuevoValor
                                                            });
                                                        }
                                                    }

                                                    // Guardar en la base de datos
                                                    await guardarSwitch(nuevoValor);
                                                }}
                                                disabled={isSaving}
                                                className={`${enabled ? 'bg-green-600' : 'bg-gray-200'} 
                                                    relative inline-flex h-6 w-11 items-center rounded-full transition-colors 
                                                    focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2
                                                    ${isSaving ? 'opacity-50 cursor-not-allowed' : ''}`}
                                            >
                                                <span className="sr-only">Trabaja en IT Rossmon</span>
                                                <span
                                                    className={`${enabled ? 'translate-x-6' : 'translate-x-1'} 
                                                        inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
                                                />
                                            </Switch>
                                            <span className={`text-sm font-medium ${enabled ? 'text-green-600' : 'text-gray-500'}`}>
                                                {enabled ? 'Sí' : 'No'}
                                            </span>
                                            {isSaving && (
                                                <svg className="animate-spin h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}